import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "15",
  viewBox: "0 0 16 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.84714 3.103C1.52752 4.42262 1.52752 6.56214 2.84714 7.88176L7.96552 13.0001L8.0007 12.965L8.03592 13.0002L13.1543 7.8818C14.4739 6.56218 14.4739 4.42266 13.1543 3.10304C11.8347 1.78342 9.69516 1.78342 8.37554 3.10304L8.25031 3.22827C8.11248 3.3661 7.88901 3.3661 7.75117 3.22827L7.6259 3.103C6.30628 1.78338 4.16675 1.78338 2.84714 3.103Z",
      stroke: "#303333"
    }, null, -1)
  ])))
}
export default { render: render }